import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Button, Modal, ModalContent, TextButton} from '@spothero/ui-backlog';

export default class AlertModal extends Component {
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string,
        message: PropTypes.node,
        confirmButtonLabel: PropTypes.string,
        showRejectButton: PropTypes.bool,
        rejectButtonLabel: PropTypes.string,
        onHidden: PropTypes.func.isRequired,
        onConfirm: PropTypes.func,
        onReject: PropTypes.func,
        showClose: PropTypes.bool,
        modalWidth: PropTypes.string,
    };
    static defaultProps = {
        confirmButtonLabel: 'Okay',
        rejectButtonLabel: 'Cancel',
        showClose: true,
        modalWidth: 'slim',
    };

    _onConfirmClick = () => {
        const {onConfirm} = this.props;

        if (onConfirm) {
            onConfirm();
        }

        this._modal.hide();
    };

    _onRejectClick = () => {
        const {onReject} = this.props;

        if (onReject) {
            onReject();
        }

        this._modal.hide();
    };

    render() {
        const {
            className,
            title,
            message,
            confirmButtonLabel,
            showRejectButton,
            rejectButtonLabel,
            onReject,
            onHidden,
            showClose,
            modalWidth,
        } = this.props;
        const classes = classNames('AlertModal', className);

        return (
            <Modal
                ref={node => {
                    this._modal = node;
                }}
                className={classes}
                title={title}
                width={modalWidth}
                showClose={showClose}
                onHidden={onHidden}
                onCloseClick={onReject}
            >
                <ModalContent>
                    {message}
                    <div className="FormActions">
                        <Button color="primary" onClick={this._onConfirmClick}>
                            {confirmButtonLabel}
                        </Button>
                        {showRejectButton && (
                            <TextButton onClick={this._onRejectClick}>
                                {rejectButtonLabel}
                            </TextButton>
                        )}
                    </div>
                </ModalContent>
            </Modal>
        );
    }
}
